'use client'

import { 
    Button,
    Container,
    Icon,
    Link,
    List,
    ListItem,
    TitleBackgroundBlock,
    Typography,
} from '@shc/ui'
import { formatDate } from '@lib/constants'
import ProvidersEventsWidget from '@components/providers-events-widget'

interface ProvidersHomeProps {
    displayname: string,
    reports: any[] | undefined,
    news2know: any[] | undefined,
    events?: any[] | undefined
    features: string[]
}

const ProvidersHome = ({ displayname, reports, news2know, events = [], features } : ProvidersHomeProps) => {
    const rawEvents = Array.isArray(events) ? events : []
    return (
        <>
            <TitleBackgroundBlock
                id='providers-hello'
                heading={ (
                    <>
                        <Icon className='mr-4' icon="user" />
                        {displayname ? `Welcome, ${displayname}` : 'Welcome'}
                    </>
                ) }
                alignment={'left'}
                className={'bg-primary text-white'}
                description=''
                image={{
                    src: undefined,
                    className: 'hidden'
                }}
            />
            <Container className="pt-15 grid grid-cols-6 lg:grid-cols-12 lg:gap-12 xl:gap-15">
                { news2know && (

                    <Container className='col-span-6 lg:col-span-4 pt-0'>
                        <Typography paragraph={false} variant={'h2'}>News2Know</Typography>
                        <List variant='none' className='pr-8'>
                            { news2know?.length > 0 && news2know.map((n2k:any) => {
                                return (
                                    <ListItem className="my-8 providers-home" key={n2k.objectID}>
                                        <Typography paragraph={true} variant='small-body'>{formatDate(n2k.publishedDate)}</Typography>
                                        <Container className='flex flex-row'>
                                            <Link href={`/providers/news2know/${n2k.slug}`} className='no-underline hover:underline'>{n2k.title}</Link>
                                        </Container>
                                    </ListItem>
                                )
                            })}
                        </List>
                        <Button
                            variant='filled'
                            href='/providers/search/news2know'
                            size='md'
                            width='lg'
                        >
                            View all articles
                        </Button>
                    </Container>

                )}
                { reports && reports.length > 0 && (
                    
                    <Container className='col-span-6 lg:col-span-4 pt-12 lg:pt-0'>
                        <Typography paragraph={false} variant={'h2'}>Physician reports</Typography>
                        <List variant='none'>
                            { reports.length > 0 && reports.map((report:any) => {
                                return (
                                    <ListItem className="my-8 providers-reports" key={report.name}>
                                        { report.isNew && (<Typography variant='small-body-semibold' className='mr-2'>New</Typography>) }
                                        <Typography paragraph={true} variant='small-body'>{formatDate(`${report.date}T10:00:00.000Z`)}</Typography>
                                        <Container className='flex flex-row'>
                                            <Link href={report.url} target='_blank' className='no-underline hover:underline'>{report.filename}</Link>
                                            {report.providername && (<Typography variant='body' className='ml-2'>({report.providername})</Typography>)}
                                        </Container>
                                    </ListItem>
                                )
                            })}
                        </List>
                        <Button 
                            variant='filled'
                            href='/providers/search/reports'
                            size='md'
                            width='lg'
                        >
                            Search reports
                        </Button>
                    </Container>
                )}
                {/* Events widget - far right column */}
                { features.includes('events') && (
                    <ProvidersEventsWidget events={rawEvents} />
                )}
            </Container>
        </>
    ) 
}

export default ProvidersHome